__turbopack_context__.v({
  "icon": "upsizedCell-module-scss-module__nY_ZqG__icon",
  "upsizedCol": "upsizedCell-module-scss-module__nY_ZqG__upsizedCol",
  "upsizedTooltip": "upsizedCell-module-scss-module__nY_ZqG__upsizedTooltip",
});
